import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsersGear, faWrench } from '@fortawesome/free-solid-svg-icons';

const AgentToolToggle = ({ activeView, setActiveView }) => {
    const activeTabStyle =
        'bg-backgrounds-primary100 text-buttons-primary shadow-inner';
    const inactiveTabStyle = 'text-gray-400 hover:bg-backgrounds-white';
    const commonTabStyle =
        'flex-1 flex items-center justify-center gap-2 py-2 px-4 cursor-pointer rounded-lg transition-colors duration-200 ease-in-out';

    return (
        <div className='w-full flex bg-backgrounds-slate p-1'>
            {/* Agents Tab */}
            <div
                className={`${commonTabStyle} ${
                    activeView === 'agents' ? activeTabStyle : inactiveTabStyle
                }`}
                onClick={() => setActiveView('agents')}
            >
                <div className='w-6 h-6 rounded-full bg-white flex items-center justify-center'>
                    <FontAwesomeIcon icon={faUsersGear} />
                </div>
                <span className='font-semibold whitespace-nowrap'>Agents</span>
            </div>

            {/* Tools Tab */}
            <div
                className={`${commonTabStyle} ${
                    activeView === 'tools' ? activeTabStyle : inactiveTabStyle
                }`}
                onClick={() => setActiveView('tools')}
            >
                <div className='w-6 h-6 rounded-full bg-white flex items-center justify-center'>
                    <FontAwesomeIcon icon={faWrench} />
                </div>
                <span className='font-semibold whitespace-nowrap'>Tools</span>
            </div>
        </div>
    );
};

export default AgentToolToggle;
